//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import { AbstractProgramModel, AbstractProgramNavModel } from "@app/catalog-common";
import { PresenterRegistration } from "@app/shared";

@PresenterRegistration({
  types: [AbstractProgramNavModel]
})
@Component({
  selector: "program-nav-item",
  standalone: false,
  templateUrl: "./programs-nav-item.component.html",
  styleUrl: "./program-nav-item.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgramsNavItemComponent<TProgram extends AbstractProgramModel> {
  public data: WritableSignal<AbstractProgramNavModel<TProgram>> = signal<AbstractProgramNavModel<TProgram>>(null);

  public isActive = computed(() => {
    return this.data().items().some(item => item.isChecked());
  });
}
